var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unarchive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "unarchive_2",
    d: "M12.5 10.7885L8.84615 14.4423L9.89998 15.4961L11.75 13.6461V18.0961H13.25V13.6461L15.1 15.4961L16.1538 14.4423L12.5 10.7885ZM5.49997 8.40383V19.1923C5.49997 19.282 5.52883 19.3557 5.58653 19.4134C5.64423 19.4711 5.71795 19.5 5.8077 19.5H19.1923C19.282 19.5 19.3557 19.4711 19.4134 19.4134C19.4711 19.3557 19.5 19.282 19.5 19.1923V8.40383H5.49997ZM5.88463 21C5.38591 21 4.94712 20.8105 4.56827 20.4317C4.18942 20.0528 4 19.614 4 19.1153V7.50578C4 7.29168 4.0343 7.08751 4.1029 6.89328C4.17148 6.69906 4.27437 6.5199 4.41155 6.3558L5.8154 4.6577C5.9795 4.4436 6.18462 4.28046 6.43077 4.16828C6.67692 4.05609 6.93718 4 7.21155 4H17.7692C18.0435 4 18.3054 4.05609 18.5547 4.16828C18.8041 4.28046 19.0108 4.4436 19.1749 4.6577L20.5884 6.37503C20.7256 6.53913 20.8285 6.71989 20.8971 6.91733C20.9657 7.11476 21 7.32053 21 7.53463V19.1153C21 19.614 20.8105 20.0528 20.4317 20.4317C20.0528 20.8105 19.614 21 19.1153 21H5.88463ZM5.89035 6.90385H19.1L18.0096 5.60575C17.9775 5.5737 17.9407 5.54806 17.899 5.52883C17.8573 5.50959 17.814 5.49998 17.7692 5.49998H7.22117C7.17629 5.49998 7.13302 5.50959 7.09135 5.52883C7.04968 5.54806 7.01282 5.5737 6.98075 5.60575L5.89035 6.90385Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.aedecc832428f0f6553c92a0dd66d87f.svg";
export { ForwardRef as ReactComponent };